export const LOADING_MATRIZ_SUCESION = "LOADING_MATRIZ_SUCESION";
export const SAVE_LOADING_MATRIZ_SUCESION = "SAVE_LOADING_MATRIZ_SUCESION";
export const GET_MATRIZ_SUCESION = "GET_MATRIZ_SUCESION";
export const FORM_FAIL = "FORM_FAIL";
export const MATRIZ_SUCESION_FAIL = "MATRIZ_SUCESION_FAIL";